// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.question-text-from-server {
    margin-bottom: 5px;
    border-bottom: #b2bec3 1px solid;
    
}

.question-text-from-server span {
    font-weight: 600;
}

.answers-holder-ml-container {
    backdrop-filter: brightness(90%);
    border-radius: 10px;
    margin: 5px;
}`, "",{"version":3,"sources":["webpack://./src/app/nlp/topic-editor/topic-widget/answer-message-body/AnswerMessageBody.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,gCAAgC;;AAEpC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".question-text-from-server {\r\n    margin-bottom: 5px;\r\n    border-bottom: #b2bec3 1px solid;\r\n    \r\n}\r\n\r\n.question-text-from-server span {\r\n    font-weight: 600;\r\n}\r\n\r\n.answers-holder-ml-container {\r\n    backdrop-filter: brightness(90%);\r\n    border-radius: 10px;\r\n    margin: 5px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
